import script from "./EventCardRail.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCardRail.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/eventsExplorer.sass?vue&type=style&index=0&id=06ccb1f0&scoped=true&lang=sass"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ccb1f0"]])

export default __exports__